import classNames from "classnames"
import { useLocation, useNavigate } from "react-router-dom"
import { ROUTES } from "shared/constants/routesPaths"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { filesUploadingActions, UPLOADING_STATUSES } from "features/files-uploading/model/slice/filesUploadingSlice"
import { useAppDispatch } from "shared/config/store"

interface SidebarTabsToggleProps {
  className?: string
}

export const SidebarTabsToggle = ({ className }: SidebarTabsToggleProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const handleTabClick = (path: string) => {
    navigate(path)
  }

  return (
    <STabs className={className}>
      <STab onClick={() => handleTabClick(ROUTES.dashboard.aiAssistant)}
        className={classNames({ active: location.pathname.startsWith(ROUTES.dashboard.aiAssistant) })}
      >
        {t('a_sidebar_aivard')}
      </STab>

      <STab onClick={() => handleTabClick(ROUTES.dashboard.allAssets)}
        className={classNames({ active: !location.pathname.startsWith(ROUTES.dashboard.aiAssistant) })}
      >
        {t('a_sidebar_library')}
      </STab>
    </STabs>
  )
}

const STabs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  background-color: white;
  border-radius: 6px;
  padding: 4px;
  border: 1px solid #F0F0F0;
`

const STab = styled.button`
  flex: 1;
  height: 100%;
  color: #000000A6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: none;
  font-size: 14px;
  font-weight: 400;
  font-family: 'SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Open Sans','Helvetica Neue',sans-serif;

  &.active {
    color: var(--color-primary);
    background-color: var(--ant-color-primary-bg);
    border-color: var(--ant-color-primary-border);
  }
`
